<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["payment_receipt"] }}
        </p>
      </div>
      <div class="content_title">
        {{ new Date().toLocaleString("default", { month: "short" }) }}
        {{ new Date().getDate() }}, {{ new Date().getFullYear() }}
      </div>
      <div class="fees">
        <table>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["parking_fees"] }}
            </td>
            <td style="text-align: left">{{ "$" + this.parkingCharge }}</td>
          </tr>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["valet_fees"] }}
            </td>
            <td style="text-align: left">{{ "$" + this.valetCharge }}</td>
          </tr>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["tip_given"] }}
            </td>
            <td style="text-align: left">
              ${{ this.$store.getters.LAST_PARKING_TIP || 0 }}
            </td>
          </tr>
          <tr>
            <td style="text-align: right">
              {{ this.$store.getters.TRANSLATIONS["hst_taxes"] }}
            </td>
            <td style="text-align: left">{{ "$" + this.taxCharge }}</td>
          </tr>
        </table>
      </div>

      <div class="total">
        <p class="title">{{ this.$store.getters.TRANSLATIONS["total"] }}</p>
        <br />
        <p class="amount">
          ${{
            this.totalAmount
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
          }}
        </p>
      </div>
    </div>

    <div class="footer" v-if="!loading">
      <button class="button" v-on:click="payWithCreditCard()">
        {{ this.$store.getters.TRANSLATIONS["credit_card"] }}
      </button>
      <!-- <button class="button" v-on:click="payWithValetStand()">VALET STAND</button> -->
      <button class="button remove-tip" v-on:click="removeTipAndProceed()">
        {{ this.$store.getters.TRANSLATIONS["remove_tip"] }}
      </button>
    </div>

    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
import StarRating from "vue-star-rating";

export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.loading = true;
      this.$http
        .get(
          `${process.env.SERVER_URL}/F0B659FCE0414D869F2A05C012553E82/${this.$store.getters.REQUESTED_VEHICLE.id}`,
          {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          }
        )
        .then((response) => {
          console.log("Requested vehicle info response:");
          console.log(response);
          if (response && response.data) {
            console.log("HERE123");
            this.taxCharge = response.data.taxCharge;
            this.valetCharge = response.data.valetCharge;
            this.parkingCharge = response.data.parkingCharge;
            if (response.data.status === "P") {
              this.$router.push("/freeParking");
            }
            if (
              response.data.paymentType === "LC" ||
              response.data.paymentType === "V"
            ) {
              this.showCreditApplied = true;
              this.creditsApplied = response.data.paymentCredit;
            }
            if (!this.$storage.get("lastParkingTip")) {
              this.$store.dispatch(
                "SAVE_LAST_PARKING_TIP",
                response.data.tipCharge
              );
            }
            this.totalAmount =
              this.valetCharge +
              this.parkingCharge +
              parseFloat(this.$store.getters.LAST_PARKING_TIP) -
              this.creditsApplied;
            if (
              response.data.paymentCredit &&
              response.data.paymentCredit ===
                this.valetCharge + this.parkingCharge
            ) {
              this.valetCharge = 0;
              this.parkingCharge = 0;
            }

            this.$store.dispatch("SAVE_TOTAL_AMOUNT", this.totalAmount);
          }
        })
        .catch((error) => {
          let text = this.$store.getters.TRANSLATIONS["can_not_get_requested"];
          this.$modal.show("dialog", {
            text,
            buttons: [
              {
                title: "Home",
                handler: () => {
                  window.location.replace("/#/home");
                  window.location.reload();
                }
              },
              {
                title: "Re-try",
                handler: () => {
                  window.location.replace("/#/parkingReceiptFinal");
                  window.location.reload();
                }
              }
            ]
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  data() {
    return {
      loading: false,
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      rating: 4,
      totalAmount: 0,
      parkingCharge: 0,
      valetCharge: 0,
      taxCharge: 0,
      creditsApplied: 0,
      showCreditApplied: false,
      payWithValetStand: () => {
        this.$router.push(`/payWithValetStand`);
      },
      payWithCreditCard: () => {
        this.$router.push(`/payWithSquareUpCreditCard`);
      },
      removeTipAndProceed: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/79fe0c5cf33e4de183b2c42510673434`,
            {
              paymentStatusId: this.$storage.get("requestedVehicleInfo").id
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Remove tip response:");
            console.log(response);
            this.$router.push("/paymentProcessed");
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["can_not_remove_tip"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/home");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.go(-1);
      }
    };
  },
  components: {
    StarRating
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.header {
  height: 50px;
}
.fees {
  border-radius: 20px;
  display: block;
  background-color: #fbae31;
  padding: 1vh 0px;
  margin: 0 10vw;
}
.fees table {
  width: 100%;
  text-align: center;
  font-size: 5vw;
}
.fees table tr td {
  padding: 0.5vh 5vw;
  width: 50%;
  color: white;
  font-size: 4vw;
}
.fees table tr {
  width: 50%;
}
.fees table tr td:first-child {
  border-right: 1px solid white !important;
}

.total {
  margin: 3vh 17vw 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.total .amount,
.total .title {
  font-size: 5vw;
  color: white;
}

.footer {
  height: 30vh;
}

.second {
  background-color: white;
  color: #fbae31;
}
.third {
  background-color: rgba(114, 174, 255, 1);
  color: white;
}
.fourth {
  background-color: white;
  color: rgba(114, 174, 255, 1);
}

.remove-tip {
  background-color: rgba(114, 174, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/ParkingReceiptFinal.vue